<!-- button-reset class is needed for backwards compatibility with adding the storyblok color -->
@if(!!button?.URL && !button?.hidden){
@if (href?.startsWith("/")) {
<a [ngClass]="get_class(button.type)" class="group {{button.color? 'button-reset':''}} {{button.color}} {{button.hovercolor}} transition-colors"
    [target]="button.URL?.target ? button.URL.target : '_self'" [routerLink]="href" [queryParams]="queryparams" [fragment]="fragment">
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</a>
}@else {
<a [ngClass]="get_class(button.type)" class="group {{button.color? 'button-reset':''}} {{button.color}} {{button.hovercolor}} transition-colors"
    [target]="button.URL?.target ? button.URL.target : '_self'" [href]="href">
    <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
</a>
}
}
<ng-template #buttonContent>
    @switch (button.type) {
    @case ('BIG') {
    <div [innerHtml]="renderedTitle"></div>
    <img class="inline rotate-[-90deg] h-8 mb-6 group-hover:hidden"  height="32" alt="arrow right"
        src="./assets/images/icons/arrow_down{{['e-dark-green', 'e-orange'].includes(button.colorname) ? '_white': ''}}.svg" />
    <img class="group-hover:inline rotate-[-90deg] h-8 mb-6 hidden" height="32" alt="arrow right" src="./assets/images/icons/arrow_down.svg" />
    }
    @case ('BIG_DARKGREEN') {
    <div class="duration-100 transition-transform hover:scale-105">
        <div class="font-serif" [innerHtml]="renderedTitle"></div>
        @if (button.subtitle) {
        <div class="flex flex-row justify-between mt-6">
            <small class="font-serif text-sm">{{ button.subtitle }}</small>
            @if(button.color){
            <img class="h-5 w-7 inline group-hover:hidden" height="20" width="28" src="./assets/images/icons/arrow_right{{['e-dark-green', 'e-orange'].includes(button.colorname) ? '_white': ''}}.svg"  alt="arrow right" />
            <img class="h-5 w-7 group-hover:inline hidden" height="20" width="28" src="./assets/images/icons/arrow_right.svg" alt="arrow right" />
            }@else {
            <img class="h-5 w-7" height="20" width="28" src="./assets/images/icons/arrow_right_green.svg" alt="arrow right" />
            }
        </div>
        }
    </div>
    }
    @case ('ORANGE') {
    <div [innerHtml]="renderedTitle"></div>
    <i class="my-auto bi bi-chevron-right"></i>
    }
    @default {
    <div [innerHtml]="renderedTitle"></div>
    }
    }
</ng-template>